module.exports = __webpack_public_path__ + "img/icon-home-notice-active.8cf3a53b.svg";